<template>
	<div style="overflow: hidden;">
		<div class="filter-block">
			<div class="filter-title">
				{{lang === 'zh' ? '分类' : 'Category'}}：
			</div>
			<div v-for="(item, index) in typeList" :key="index" class="filter-title" style="cursor: pointer;" @click="changeType(item.id)" :style="{backgroundColor: params.collectionType === item.id ? '#3F89EA' : '', color: params.collectionType === item.id ? '#FFFFFF' : ''}">
				{{item.name}}
			</div>
		</div>
		<div class="collection-block">
			<div class="collection-main">
				<div class="collection-box" v-for="(item, index) in collectionList" :key="index" @click="toDetails(item.id)">
					<img :src="$imgUrl + item.listImgPc" alt="">
					<div style="margin-top: 5px; color: #001c54; font-size: 16px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%; height: 22px; line-height: 22px; text-align: center;">
						{{item.collectionTypeName}}</span>{{item.title}}
					</div>
					<div style="margin-top: 5px; color: #666666; font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%; height: 22px; line-height: 22px; text-align: center;">
						{{item.shortTitle}}
					</div>
				</div>
			</div>
			<page :pageObj="params" @getDataList="getCollectionList" ref="page"></page>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page,
		},
		data () {
			return {
				params: {
					current: 1,
					size: 6,
					channelId: this.$store.state.channelId,
					title: '',
					collectionType: '',
					releaseTerrace: "releasePc"
				},
				collectionList: [],
				typeList: [

				],
			}
		},
		computed: {
			lang() {
				return this.$store.state.lang
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_3.png'
			that.getTypeList()

		},
		methods: {
			getTypeList() {
				let that = this
				if(this.lang === 'zh') {
					that.typeList = [
						{
							name: '全部',
							id: ''
						}
					]
				} else {
					that.typeList = [
						{
							name: 'All',
							id: ''
						}
					]
				}

				that.$http.post({
					url: '/api/collectionType/findCollectionType',
					data: {
						siteId: 1
					}
				}).then(res => {
					if(res.code === 'S200') {
						that.typeList.push(...res.data)
					}
				})
			},
			getCollectionList(collection) {
				document.body.scrollTop = document.documentElement.scrollTop = 0
				this.collectionList = collection
				console.log(this.collectionList);
			},
			changeType(choose) {
				if(choose === this.params.collectionType) {
					return
				}
				this.params.collectionType = choose
				this.params.current = 1
				this.$refs.page.getData()
			},
			toDetails(collection_id) {
				this.$router.push({
					path: '/gcjp_xqy',
					query: {
						collection_id: collection_id
					}
				})
			},
			searchData() {
				this.params.current = 1
				this.$refs.page.getData()
			}
		}
	}
</script>

<style lang="less" scoped>
	.search-box {
		height: 37px;
		line-height: 37px;
		display: flex;
		justify-content: center;
		position: relative;
		margin: 20px 0;
		.input-box {
			position: absolute;
			right: 13%;
			top: 5px;
			width: 170px;
			padding: 0 35px 0 10px;
			height: 25px;
			border: 1px solid #264EA7;
			background-color: #FFFFFF;
			color: #1059BF;
		}
		.search-icon {
			position: absolute;
			right: 13%;
			top: 5px;
			width: 35px;
			height: 25px;
			color: #264EA7;
			line-height: 25px;
			text-align: center;
			cursor: pointer;
			i {
				font-size: 16px;
			}
		}
	}
	.filter-block {
		width: 1100px;
		margin: 30px auto 0;
		border-bottom: 2px solid #59ADFF;
		display: flex;
		justify-content: center;
		height: 40px;
		line-height: 40px;
		.filter-title {
			padding: 0 17px;
			color: #264EA7;
			margin-right: 10px;
			font-size: 16px;
			height: 40px;
			line-height: 40px;
		}
	}
	.collection-block {
		width: 1100px;
		margin: 0 auto;
		padding: 20px 0 40px;
		.collection-main {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			.collection-box {
				width: 30%;
				margin: 10px 1%;
				padding: 5px 0.5%;
				display: flex;
				flex-direction: column;
				cursor: pointer;
				background-color: #FFFFFF;
				border: 1px solid #d6d6d6;
				img {
					width: 100%;
					height: calc(100% - 44px);
				}
				text-align: left;
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/views/collection_essence/gcjp.vue